import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_86: FaireProductEntity = {
  token: "legacy_prod_abbott-86",
  type: "product",
  name: "Large Velvet Pouch with 3D Leopard, Navy Blue 5×7 L",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/87da61b433fc9e5a68362e6976a7848dae4cd96225bcd598924c5fae0e3e58f3.jpeg",
  priceDollars: 16,
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_womens-accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
